import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
    selector: 'app-alterar-credito-clientes-dialog',
    templateUrl: './alterar-credito-clientes-dialog.html',
    styleUrls: ['./alterar-credito-clientes-dialog.scss', '../../../styles/estilo.padrao.scss']
})
export class AlertaAlterarCreditoClienteDialog {
    uid;
    creditoForm: FormGroup;

    constructor(
        private dialogRef: MatDialogRef<AlertaAlterarCreditoClienteDialog>,
        private formBuilder: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: { creditoCliente: string }
    ) {
        this.uid = localStorage.getItem('uid');
    }

    ngOnInit(): void {
        console.log(this.data)
        this.creditoForm = this.formBuilder.group({
            creditoCliente: [],
            creditoEditar: [0, [Validators.required, Validators.min(-2000000), Validators.max(2000000)]],
            creditoFinal: [],
        });

        this.creditoForm.get('creditoCliente').patchValue(this.data.creditoCliente);
        this.creditoForm.get('creditoCliente').disable();

        this.creditoForm.get('creditoFinal').patchValue(this.data.creditoCliente);
        this.creditoForm.get('creditoFinal').disable();

        this.creditoForm.get('creditoEditar').patchValue(0);
    }

    onChangeCredito(event: number) {
        this.creditoForm.get('creditoFinal').patchValue(Number(this.f.creditoCliente.value) + Number(event));
    }

    onClickCancelar() {
        this.dialogRef.close();
    }

    onClickEditar() {
        this.dialogRef.close(Number(this.f.creditoEditar.value));
    }

    // convenience getter for easy access to form fields
    get f() { return this.creditoForm.controls; }
}
